import React from "react";
import { Progress, Tooltip } from "@nextui-org/react";
import AchievementIcon from "./achievementIcon";

const COLOR_TEXT = {
  default: "text-foreground-500",
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  warning: "text-warning",
  danger: "text-danger",
};

// `ranking` is the object returned by server/lib/ranking.js:
// { points, level: {key,name,color,icon}, next_level, points_to_next, progress }
export default function RankingBadge({ ranking, compact = false, className = "" }) {
  if (!ranking || !ranking.level) return null;
  const { level, next_level, points, points_to_next, progress } = ranking;

  if (compact) {
    return (
      <Tooltip content={next_level ? `${points_to_next} pts to ${next_level.name}` : "Max level reached"}>
        <div className={`flex items-center gap-1.5 ${className}`}>
          <AchievementIcon icon={level.icon} size={14} className={COLOR_TEXT[level.color] || COLOR_TEXT.default} />
          <span className={`text-small font-semibold ${COLOR_TEXT[level.color] || COLOR_TEXT.default}`}>{level.name}</span>
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <div className={`flex items-center justify-center w-9 h-9 rounded-full bg-default-100 ${COLOR_TEXT[level.color] || COLOR_TEXT.default}`}>
            <AchievementIcon icon={level.icon} size={18} />
          </div>
          <div>
            <div className={`font-bold leading-tight ${COLOR_TEXT[level.color] || COLOR_TEXT.default}`}>{level.name}</div>
            <div className="text-tiny text-foreground-400">{points} activity points</div>
          </div>
        </div>
        {next_level && (
          <div className="text-tiny text-foreground-400 text-right shrink-0">
            {points_to_next} pts to<br />
            <span className="font-medium text-foreground-600">{next_level.name}</span>
          </div>
        )}
      </div>
      <Progress
        value={Math.round(progress * 100)}
        color={level.color === "default" ? "primary" : level.color}
        size="sm"
        aria-label="Progress to next level"
      />
    </div>
  );
}
